define("shared/utils/create-tax-id-changeset", ["exports", "ember-changeset", "ember-changeset-validations", "shared/validations/tax-id-validation"], function (_exports, _emberChangeset, _emberChangesetValidations, _taxIdValidation) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-changeset",0,"ember-changeset-validations",0,"shared/validations/tax-id-validation"eaimeta@70e063a35619d71f
  var _default = taxIdData => {
    return (0, _emberChangeset.Changeset)({
      businessName: taxIdData?.businessName ?? '',
      taxId: taxIdData?.value ?? '',
      didConfirm: false
    }, (0, _emberChangesetValidations.default)(_taxIdValidation.default));
  };
  _exports.default = _default;
});